import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryHistoricalBalanceContainerModel} from '../../../../../../models/aggregates/erp/inventory';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryHistoricalBalanceService extends BaseApiTemplateService<InventoryHistoricalBalanceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-historical-balance';
    this.httpClient = http;
  }

}


